// State-City mapping for US states
// Contains major cities for each state

export const stateCityMap = {
  Alabama: [
    'Birmingham', 'Montgomery', 'Huntsville', 'Mobile', 'Tuscaloosa',
    'Hoover', 'Auburn', 'Dothan', 'Decatur', 'Madison'
  ],
  Alaska: [
    'Anchorage', 'Fairbanks', 'Juneau', 'Sitka', 'Ketchikan',
    'Wasilla', 'Kenai', 'Kodiak', 'Bethel', 'Palmer'
  ],
  Arizona: [
    'Phoenix', 'Tucson', 'Mesa', 'Chandler', 'Scottsdale',
    'Glendale', 'Gilbert', 'Tempe', 'Peoria', 'Surprise',
    'Flagstaff', 'Yuma', 'Sedona', 'Prescott', 'Lake Havasu City'
  ],
  Arkansas: [
    'Little Rock', 'Fort Smith', 'Fayetteville', 'Springdale', 'Jonesboro',
    'North Little Rock', 'Conway', 'Rogers', 'Bentonville', 'Pine Bluff'
  ],
  California: [
    'Los Angeles', 'San Diego', 'San Jose', 'San Francisco', 'Sacramento',
    'Oakland', 'Long Beach', 'Anaheim', 'Riverside', 'Irvine',
    'San Bernardino', 'Modesto', 'Oxnard', 'Fontana', 'Moreno Valley'
  ],
  Colorado: [
    'Denver', 'Colorado Springs', 'Aurora', 'Fort Collins', 'Boulder',
    'Lakewood', 'Thornton', 'Westminster', 'Pueblo', 'Arvada',
    'Aspen', 'Vail', 'Grand Junction', 'Loveland', 'Castle Rock'
  ],
  Connecticut: [
    'Hartford', 'New Haven', 'Stamford', 'Bridgeport', 'Waterbury',
    'Norwalk', 'Danbury', 'New Britain', 'Greenwich', 'Fairfield'
  ],
  Delaware: [
    'Wilmington', 'Dover', 'Newark', 'Middletown', 'Bear',
    'Glasgow', 'Brookside', 'Hockessin', 'Smyrna', 'Milford'
  ],
  Florida: [
    'Miami', 'Tampa', 'Orlando', 'Jacksonville', 'St. Petersburg',
    'Fort Lauderdale', 'Tallahassee', 'Hialeah', 'Port St. Lucie', 'Cape Coral',
    'West Palm Beach', 'Clearwater', 'Gainesville', 'Naples', 'Sarasota'
  ],
  Georgia: [
    'Atlanta', 'Augusta', 'Columbus', 'Savannah', 'Athens',
    'Sandy Springs', 'Macon', 'Roswell', 'Albany', 'Marietta',
    'Alpharetta', 'Valdosta', 'Warner Robins', 'Johns Creek', 'Gainesville'
  ],
  Hawaii: [
    'Honolulu', 'Pearl City', 'Hilo', 'Kailua', 'Waipahu',
    'Kailua-Kona', 'Kaneohe', 'Kahului', 'Mililani', 'Lihue'
  ],
  Idaho: [
    'Boise', 'Meridian', 'Nampa', 'Idaho Falls', 'Pocatello',
    'Coeur d\'Alene', 'Twin Falls', 'Lewiston', 'Post Falls', 'Rexburg'
  ],
  Illinois: [
    'Chicago', 'Aurora', 'Rockford', 'Joliet', 'Naperville',
    'Springfield', 'Peoria', 'Elgin', 'Waukegan', 'Cicero',
    'Champaign', 'Bloomington', 'Evanston', 'Schaumburg', 'Decatur'
  ],
  Indiana: [
    'Indianapolis', 'Fort Wayne', 'Evansville', 'South Bend', 'Gary',
    'Carmel', 'Fishers', 'Bloomington', 'Hammond', 'Lafayette'
  ],
  Iowa: [
    'Des Moines', 'Cedar Rapids', 'Davenport', 'Sioux City', 'Iowa City',
    'Waterloo', 'Ames', 'Council Bluffs', 'Dubuque', 'Cedar Falls'
  ],
  Kansas: [
    'Wichita', 'Kansas City', 'Overland Park', 'Olathe', 'Topeka',
    'Lawrence', 'Shawnee', 'Manhattan', 'Lenexa', 'Salina'
  ],
  Kentucky: [
    'Louisville', 'Lexington', 'Bowling Green', 'Owensboro', 'Covington',
    'Richmond', 'Georgetown', 'Florence', 'Hopkinsville', 'Nicholasville'
  ],
  Louisiana: [
    'New Orleans', 'Baton Rouge', 'Shreveport', 'Lafayette', 'Lake Charles',
    'Kenner', 'Bossier City', 'Monroe', 'Alexandria', 'Houma'
  ],
  Maine: [
    'Portland', 'Lewiston', 'Bangor', 'South Portland', 'Auburn',
    'Augusta', 'Biddeford', 'Sanford', 'Brunswick', 'Scarborough'
  ],
  Maryland: [
    'Baltimore', 'Frederick', 'Gaithersburg', 'Rockville', 'Bowie',
    'Annapolis', 'College Park', 'Salisbury', 'Laurel', 'Germantown'
  ],
  Massachusetts: [
    'Boston', 'Worcester', 'Springfield', 'Cambridge', 'Lowell',
    'Brockton', 'New Bedford', 'Lynn', 'Quincy', 'Fall River',
    'Newton', 'Somerville', 'Framingham', 'Plymouth', 'Salem'
  ],
  Michigan: [
    'Detroit', 'Grand Rapids', 'Warren', 'Sterling Heights', 'Ann Arbor',
    'Lansing', 'Flint', 'Dearborn', 'Livonia', 'Troy',
    'Kalamazoo', 'Wyoming', 'Southfield', 'Rochester Hills', 'Traverse City'
  ],
  Minnesota: [
    'Minneapolis', 'St. Paul', 'Rochester', 'Bloomington', 'Duluth',
    'Brooklyn Park', 'Plymouth', 'Minnetonka', 'Edina', 'St. Cloud'
  ],
  Mississippi: [
    'Jackson', 'Gulfport', 'Southaven', 'Hattiesburg', 'Biloxi',
    'Meridian', 'Tupelo', 'Greenville', 'Olive Branch', 'Pearl'
  ],
  Missouri: [
    'Kansas City', 'St. Louis', 'Springfield', 'Independence', 'Columbia',
    'Lee\'s Summit', 'O\'Fallon', 'St. Joseph', 'St. Charles', 'Jefferson City'
  ],
  Montana: [
    'Billings', 'Missoula', 'Great Falls', 'Bozeman', 'Butte',
    'Helena', 'Kalispell', 'Havre', 'Anaconda', 'Miles City'
  ],
  Nebraska: [
    'Omaha', 'Lincoln', 'Bellevue', 'Grand Island', 'Kearney',
    'Fremont', 'Norfolk', 'Hastings', 'Columbus', 'Papillion'
  ],
  Nevada: [
    'Las Vegas', 'Henderson', 'Reno', 'North Las Vegas', 'Sparks',
    'Carson City', 'Fernley', 'Elko', 'Mesquite', 'Boulder City'
  ],
  'New Hampshire': [
    'Manchester', 'Nashua', 'Concord', 'Dover', 'Rochester',
    'Keene', 'Portsmouth', 'Laconia', 'Lebanon', 'Claremont'
  ],
  'New Jersey': [
    'Newark', 'Jersey City', 'Paterson', 'Elizabeth', 'Edison',
    'Trenton', 'Camden', 'Clifton', 'Bayonne', 'Princeton',
    'Atlantic City', 'Hoboken', 'Union City', 'New Brunswick', 'Hackensack'
  ],
  'New Mexico': [
    'Albuquerque', 'Las Cruces', 'Rio Rancho', 'Santa Fe', 'Roswell',
    'Farmington', 'Clovis', 'Hobbs', 'Alamogordo', 'Carlsbad'
  ],
  'New York': [
    'New York City', 'Buffalo', 'Albany', 'Rochester', 'Syracuse',
    'Yonkers', 'New Rochelle', 'Mount Vernon', 'Schenectady', 'Utica',
    'Brooklyn', 'Queens', 'Manhattan', 'Bronx', 'Staten Island'
  ],
  'North Carolina': [
    'Charlotte', 'Raleigh', 'Greensboro', 'Durham', 'Winston-Salem',
    'Fayetteville', 'Cary', 'Wilmington', 'High Point', 'Asheville',
    'Chapel Hill', 'Greenville', 'Concord', 'Gastonia', 'Jacksonville'
  ],
  'North Dakota': [
    'Fargo', 'Bismarck', 'Grand Forks', 'Minot', 'West Fargo',
    'Mandan', 'Dickinson', 'Jamestown', 'Williston', 'Wahpeton'
  ],
  Ohio: [
    'Columbus', 'Cleveland', 'Cincinnati', 'Toledo', 'Akron',
    'Dayton', 'Canton', 'Youngstown', 'Parma', 'Lorain',
    'Hamilton', 'Springfield', 'Kettering', 'Elyria', 'Dublin'
  ],
  Oklahoma: [
    'Oklahoma City', 'Tulsa', 'Norman', 'Broken Arrow', 'Edmond',
    'Lawton', 'Moore', 'Midwest City', 'Stillwater', 'Enid'
  ],
  Oregon: [
    'Portland', 'Eugene', 'Salem', 'Gresham', 'Hillsboro',
    'Beaverton', 'Bend', 'Medford', 'Springfield', 'Corvallis'
  ],
  Pennsylvania: [
    'Philadelphia', 'Pittsburgh', 'Allentown', 'Erie', 'Reading',
    'Scranton', 'Harrisburg', 'Lancaster', 'Bethlehem', 'York',
    'State College', 'Wilkes-Barre', 'Chester', 'Bethel Park', 'Monroeville'
  ],
  'Rhode Island': [
    'Providence', 'Warwick', 'Cranston', 'Pawtucket', 'East Providence',
    'Woonsocket', 'Coventry', 'Cumberland', 'North Providence', 'Newport'
  ],
  'South Carolina': [
    'Charleston', 'Columbia', 'North Charleston', 'Mount Pleasant', 'Rock Hill',
    'Greenville', 'Summerville', 'Spartanburg', 'Myrtle Beach', 'Florence'
  ],
  'South Dakota': [
    'Sioux Falls', 'Rapid City', 'Aberdeen', 'Brookings', 'Watertown',
    'Mitchell', 'Yankton', 'Pierre', 'Huron', 'Spearfish'
  ],
  Tennessee: [
    'Nashville', 'Memphis', 'Knoxville', 'Chattanooga', 'Clarksville',
    'Murfreesboro', 'Franklin', 'Jackson', 'Johnson City', 'Bartlett'
  ],
  Texas: [
    'Houston', 'San Antonio', 'Dallas', 'Austin', 'Fort Worth',
    'El Paso', 'Arlington', 'Corpus Christi', 'Plano', 'Laredo',
    'Lubbock', 'Irving', 'Garland', 'Amarillo', 'Grand Prairie'
  ],
  Utah: [
    'Salt Lake City', 'West Valley City', 'Provo', 'West Jordan', 'Orem',
    'Sandy', 'Ogden', 'St. George', 'Layton', 'Park City'
  ],
  Vermont: [
    'Burlington', 'Essex', 'South Burlington', 'Rutland', 'Barre',
    'Montpelier', 'Bennington', 'Brattleboro', 'Hartford', 'Middlebury'
  ],
  Virginia: [
    'Virginia Beach', 'Norfolk', 'Chesapeake', 'Richmond', 'Newport News',
    'Alexandria', 'Hampton', 'Portsmouth', 'Roanoke', 'Arlington',
    'Lynchburg', 'Suffolk', 'Fairfax', 'Charlottesville', 'Williamsburg'
  ],
  Washington: [
    'Seattle', 'Spokane', 'Tacoma', 'Vancouver', 'Bellevue',
    'Kent', 'Everett', 'Renton', 'Federal Way', 'Yakima',
    'Bellingham', 'Auburn', 'Olympia', 'Marysville', 'Redmond'
  ],
  'West Virginia': [
    'Charleston', 'Huntington', 'Morgantown', 'Parkersburg', 'Wheeling',
    'Fairmont', 'Martinsburg', 'Beckley', 'Clarksburg', 'Weirton'
  ],
  Wisconsin: [
    'Milwaukee', 'Madison', 'Green Bay', 'Kenosha', 'Racine',
    'Appleton', 'Waukesha', 'Oshkosh', 'Eau Claire', 'Janesville'
  ],
  Wyoming: [
    'Cheyenne', 'Casper', 'Laramie', 'Gillette', 'Rock Springs',
    'Sheridan', 'Green River', 'Evanston', 'Jackson', 'Cody'
  ]
};

// Helper function to get cities for a state
export const getCitiesForState = (state) => {
  return stateCityMap[state] || [];
};

// Get all states as options for Select component
export const stateOptions = Object.keys(stateCityMap).map(state => ({
  label: state,
  value: state
}));

// Convert cities array to options for Select component
export const getCityOptions = (cities) => {
  return cities.map(city => ({
    label: city,
    value: city
  }));
};